// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.css';
Vue.config.productionTip = false

import axios from 'axios'
import http from './common/http'
import utils from './common/utils'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import store from './store'

Vue.prototype.$axios = axios
Vue.prototype.$utils = utils   //放入全局
Vue.prototype.$ajax = http   //放入全局
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    WeixinJSBridge.call('hideOptionMenu');
});


// WEBPACK FOOTER //
// ./src/main.js